import React, {useEffect, useState, useContext} from "react";
import { Input, Form } from 'antd';
import PagedList from "@common/PagedList";
import Button from "@common/Button";
import ButtonsGroup from "@common/ButtonsGroup";
import axios from "@common/axios";
import useCurrentConcept from "@hooks/useCurrentConcept";
import {UserContext} from "@context/UserContext";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {DownloadFileIcon, PrintIcon, RoundTick} from "@common/icons";
import {BrandContext} from "@context/BrandContext";

const { TextArea } = Input;

const thisResultTableColumns = [
    {
        title: 'Teacher',
        dataIndex: 'teacher',
    },
    {
        title: 'Test',
        dataIndex: 'test',
    },
    {
        title: 'Date',
        dataIndex: 'date',
    },
    {
        title: 'Due',
        dataIndex: 'due',
    },
    {
        title: 'Actions',
        dataIndex: 'actions',
    },
]
const testSkillsTableColumns = [
    {
        title: 'Progress',
        dataIndex: 'progress',
    },
    {
        title: '#',
        dataIndex: 'key',
    },
    {
        title: 'Skill tested',
        dataIndex: 'skill',
    },
    {
        title: 'Textbook',
        dataIndex: 'textbook',
    },
    {
        title: 'Curriculum',
        dataIndex: 'curriculum',
    },
]
const skillResourcesTableColumns = [
    {
        title: 'Skill number',
        dataIndex: 'key',
    },
    {
        title: 'Revisit this section',
        dataIndex: 'textbook',
    },

    {
        title: 'Watch these worked example videos',
        dataIndex: 'videos',
    },
    {
        title: 'See how you go with these',
        dataIndex: 'examples',
    },
    {
        title: 'Do these exercise questions',
        dataIndex: 'questions',
    },
]

const StudentDiagnosticReport = props => {
    const {testResultId, emptyText, handleFollowUpWork} = props;
    const brandConfig = useContext(BrandContext);
    const [planNotesForm] = Form.useForm();
    const [testResult, setTestResult] = useState([]);
    const [loading, setLoading] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [thisResultTableData, setThisResultTableData] = useState([]);
    const [testSkillsTableData, setTestSkillsTableData] = useState([]);
    const [skillResourcesTableData, setSkillResourcesTableData] = useState([]);
    const {user} = useContext(UserContext);
    const userContext = useContext(UserContext).user;
    const {loadCurrentConcept} = useCurrentConcept();


    useEffect(() => {
        axios.get('/web/ui/test/viewStudentDiagnosticTestFeedback', {params: {testResultId: testResultId}})
            .then(response => {
                setTestResult(response.data);
                planNotesForm.setFieldsValue({planNotes: response.data.notes});
                let newThisResultTableData = [];
                newThisResultTableData.push({
                    key: 1,
                    teacher: response.data.teacherName,
                    test: response.data.testName,
                    date: response.data.feedbackAssignedDate ? userContext.dateTimeFormat.format(new Date(response.data.feedbackAssignedDate)) : 'N/A',
                    due: response.data.feedbackDueDate ? userContext.dateTimeFormat.format(new Date(response.data.feedbackDueDate)) : 'N/A',
                    actions: (
                        <ButtonsGroup>
                            <Button onClick={handlePDF}>Export PDF<DownloadFileIcon className="margin-l--m"/></Button>
                        </ButtonsGroup>
                    ),
                })
                setThisResultTableData(newThisResultTableData);
                let newTestSkillsTableData = [];
                response.data.testResultSkills.map((skill, index) => {
                    newTestSkillsTableData.push({
                        progress: <div className="flex">{(skill.markPercent >= 0.75 ? <RoundTick className="ch-diag-progIcon-high"/> : (skill.markPercent >= 0.5 ? <RoundTick className="ch-diag-progIcon-mid"/> : <RoundTick className="ch-diag-progIcon-low"/>))}</div>,
                        key: (index + 1),
                        skill: skill.name,
                        textbook: skill.textbookTopicName,
                        curriculum: skill.curriculumTopicName,
                    });
                });
                setTestSkillsTableData(newTestSkillsTableData);
                let newSkillResourcesTableData = [];

                Object.keys(response.data.skillResources).forEach((skillId, index) => {
                    let newResourcesTableDataObj = {
                        key: (index + 1),
                    };
                    response.data.skillResources[skillId].map((skillResource) => {
                        if (skillResource.resourceType === "CONCEPT") {
                            newResourcesTableDataObj.textbook =
                                <a tabIndex={0}
                                   onClick={() => loadCurrentConcept(skillResource.conceptId, <skillResource className="tabHash"></skillResource>)}
                                   onKeyDown={(e) => {
                                       if (e.key === 'Enter' || e.key === ' ') {
                                           e.preventDefault();
                                           loadCurrentConcept(skillResource.conceptId, <skillResource className="tabHash"></skillResource>);
                                       }
                                   }}
                                >{skillResource.textbookConceptName}</a>;
                        } else if (skillResource.resourceType === "QUESTION_CLUSTER") {
                            newResourcesTableDataObj.questions =
                                <a tabIndex={0}
                                   onClick={() => loadCurrentConcept(skillResource.conceptId, skillResource.tabHash)}
                                   onKeyDown={(e) => {
                                       if (e.key === 'Enter' || e.key === ' ') {
                                           e.preventDefault();
                                           loadCurrentConcept(skillResource.conceptId, skillResource.tabHash);
                                       }
                                   }}
                                >{skillResource.resourceNumber + ': '+skillResource.resourceSubNumbers}</a>;
                        } else if (skillResource.resourceType === "QUESTION") {
                            if (skillResource.questionType === 'QUESTION') {
                                newResourcesTableDataObj.questions =
                                    <a tabIndex={0}
                                       onClick={() => loadCurrentConcept(skillResource.conceptId, skillResource.tabHash)}
                                       onKeyDown={(e) => {
                                           if (e.key === 'Enter' || e.key === ' ') {
                                               e.preventDefault();
                                               loadCurrentConcept(skillResource.conceptId, skillResource.tabHash);
                                           }
                                       }}
                                    >{skillResource.resourceNumber + ': '+skillResource.resourceSubNumbers}</a>;
                            } else if (skillResource.questionType === 'WALKTHROUGH') {
                                newResourcesTableDataObj.walkthroughs =
                                    <a tabIndex={0}
                                       onClick={() => loadCurrentConcept(skillResource.conceptId, skillResource.tabHash)}
                                       onKeyDown={(e) => {
                                           if (e.key === 'Enter' || e.key === ' ') {
                                               e.preventDefault();
                                               loadCurrentConcept(skillResource.conceptId, skillResource.tabHash);
                                           }
                                       }}
                                    >
                                        <p>
                                            {skillResource.resourceSubNumbers.split(',').map((subNumber, index) => {
                                                return <>{index > 0 ? <>,<br/> </> : <></>}Now You Try {subNumber}</>
                                            })}
                                        </p>
                                    </a>;
                            }
                        } else if (skillResource.resourceType === "TUTORIAL" && skillResource.mediaId) {
                            if (skillResource.tutorialSubType === "EXAMPLE") {
                                newResourcesTableDataObj.examples =
                                    <a
                                        tabIndex={0}
                                        onClick={() => openExampleDialog(skillResource.conceptId, skillResource.tutorialId, null, skillResource.mediaName)}
                                    >
                                        Now You Try {skillResource.mediaName?.toLowerCase().replace('example','')}
                                    </a>
                                newResourcesTableDataObj.videos =
                                    <a tabIndex={0}
                                       onClick={() => openVideoDialog(skillResource.mediaId)}
                                       onKeyDown={(e) => {
                                           if (e.key === 'Enter' || e.key === ' ') {
                                               e.preventDefault();
                                               openVideoDialog(skillResource.mediaId);
                                           }
                                       }}
                                    >{skillResource.mediaName}</a>;
                            }
                        }
                    });

                    skillResourcesTableColumns.forEach((column) => {
                        if (column.dataIndex !== 'key' && newResourcesTableDataObj[column.dataIndex] === undefined) {
                            newResourcesTableDataObj[column.dataIndex] = 'n/a';
                        }
                    });

                    newSkillResourcesTableData.push(newResourcesTableDataObj);
                });
                setSkillResourcesTableData(newSkillResourcesTableData);
                setLoading(false);
            })
    }, []);

    function handleUpdateNote() {
        setDisabled(true);
        const planNotes = planNotesForm.getFieldsValue('planNotes');
        axios.post('/web/ui/test/updateNotes', null, {params: {testResultId: testResultId, notes: planNotes.planNotes}})
            .then(response => {
                displayToastMessage('Update successful', '', 'success', undefined, 4000);
                setDisabled(false);
            }).catch((error) => {
                console.error('Error loading search resources', error);
                setDisabled(false);
            }).finally(() => {
                setDisabled(false);
            });
    }

    const handleBack = () => {
        window.location.hash = '';
        history.replaceState({}, document.title, window.location.pathname);
    }

    const handlePDF = async () => {
        globalReactFunctions.showSnackbar('In progress','PDF is generating. This may take a few moments', 'info', true, 0, true);
        setTimeout(() => {
            const content = document.getElementById('sdr');
            html2canvas(content, {
                onclone: clonedDoc => {
                    const buttons = clonedDoc.querySelectorAll('button');
                    buttons.forEach(button => {
                        button.remove();
                    });
                },
            }).then(canvas => {
                globalReactFunctions.hideSnackbar();
                const imgData = canvas.toDataURL('image/png');
                const pdf = new jsPDF();
                pdf.addImage(imgData, 'PNG', 10, 10, 190, 0);
                const pdfBlob = pdf.output('blob');
                const pdfUrl = URL.createObjectURL(pdfBlob);

                const pdfTab = window.open(pdfUrl);
                if (pdfTab !== null) {
                    const dispositionHeader = `inline; filename="test.pdf"`;
                    const blobWithDisposition = new Blob([pdfBlob], { type: 'application/pdf' });
                    const blobUrl = URL.createObjectURL(blobWithDisposition);
                    pdfTab.location.href = blobUrl;
                    // pdfTab.location.replace(pdfTab.location.href + '#' + encodeURIComponent(dispositionHeader));
                }
            });
        }, 1);
    }

    return (
        <div id="sdr">
            <div className="clearfix margin-b--l">
                <Button className="float-end" onClick={handleBack}>Back</Button>
                <h2>{brandConfig.diagnosticFeedbackName}</h2>
            </div>
            <PagedList columns={thisResultTableColumns} dataSource={thisResultTableData} emptyText={emptyText} loading={loading} />
            <div className="ch-emph-block padding--xl margin-y--l">
                <div className="flexRow flexSpaceBetween">
                    <h2 className="flex margin-b--l">Skills that were covered in this test:</h2>
                    <div className="ch-emph-block ch-surface-bg flexCol margin-b--l padding--l">
                        <div className="align-center">
                            <span className="ch-h3 margin-b--l">Progress</span>
                        </div>
                        <div className="flexRow flexAlignCentre">
                            <RoundTick className="ch-diag-progIcon-high margin-r--m" />
                            <span className="margin-r--l">Skills I can do well</span>
                            <RoundTick className="ch-diag-progIcon-mid margin-r--m" />
                            <span className="margin-r--l">Skills I need to improve</span>
                            <RoundTick className="ch-diag-progIcon-low margin-r--m" />
                            <span>Skills I haven’t shown I can do yet</span>
                        </div>
                    </div>
                </div>
                <PagedList columns={testSkillsTableColumns} dataSource={testSkillsTableData} emptyText={emptyText} loading={loading} />
            </div>
            { (testResult.classFeedbackMessage != null || testResult.feedbackMessage != null) && (
                <div className="ch-emph-block padding--xl margin-b--l">
                    <h2 className="margin-b--l">Teacher comments</h2>
                    { testResult.classFeedbackMessage != null && (
                        <p>{testResult.classFeedbackMessage}</p>
                    )}
                    { testResult.feedbackMessage != null && (
                        <p>{testResult.feedbackMessage}</p>
                    )}
                </div>
            )}
            <div className="ch-emph-block padding--xl margin-b--l">
                <h2 className="margin-b--l">What could I do to improve my skills?</h2>
                <PagedList
                    columns={skillResourcesTableColumns}
                    dataSource={skillResourcesTableData}
                    emptyText={emptyText}
                    loading={loading}
                    footer={() => (
                        <>
                            {user.testResultId != testResultId ?
                                <Button className="float-end" onClick={() => handleFollowUpWork(testResultId)}>
                                    Start {brandConfig.diagnosticFeedbackName.toLowerCase()}
                                </Button> :
                                <Button className="float-end" type="outline" onClick={() => handleFollowUpWork(undefined)}>
                                    Unpin {brandConfig.diagnosticFeedbackName.toLowerCase()}
                                </Button>
                            }
                            <b>Consider also:</b>
                            <ul>
                                <li>Printing off this feedback report to help keep track of your progress.</li>
                                <li>Making an appointment with your teacher to chat about the topics you had trouble with.</li>
                            </ul>
                        </>
                    )}
                />
            </div>
            <div className="ch-emph-block padding--xl">
                <h2 className="margin-b--l">My plan of action</h2>
                <Form form={planNotesForm}>
                    <Form.Item label="Plan goals" htmlFor="planNotes" name="planNotes">
                        <TextArea
                            id="planNotes"
                            className="margin-b--l"
                            placeholder="Write your plans for achieving your goals here"
                        />
                    </Form.Item>
                    <ButtonsGroup className='text-end' position='right'>
                        <Button onClick={handleUpdateNote} disabled={disabled}>Save</Button>
                    </ButtonsGroup>
                </Form>
            </div>
        </div>
    )
}

export default StudentDiagnosticReport;